/* ==========================================================================
   LUNÉA COSMETICS — Chatwidget "Evelyne"
   Praat met de n8n-workflow "LUNEA · EVELYNE CHATBOT".

   Protocol
     Chat      POST <chatUrl>      { action: 'sendMessage', sessionId, chatInput, metadata }
                                   ← { output: "markdown + optionele blokken" }
     Doorsturen POST <escalateUrl> { email, naam, vraag, toestemming, gesprek, pagina, sessionId, website }
                                   ← { ok: true }

   Blokken in het antwoord van Evelyne (zie systeemprompt):
     ```producten  ["handle", ...]         → productkaarten (live uit /products/<handle>.js)
     ```keuzes     ["optie", ...]          → keuzeknoppen
     ```doorsturen {"vraag": "..."}        → e-mailformulier naar het team

   Vanilla JS, geen afhankelijkheden. Faalt stil als de configuratie ontbreekt.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__luneaEvelyne) return;
  window.__luneaEvelyne = true;

  var cfgEl = document.getElementById('lunea-evelyne-config');
  var root = document.getElementById('lunea-evelyne');
  if (!cfgEl || !root) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.chatUrl) return;

  var SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ----------------------------------------------------------------------
     Taal — vaste teksten van de widget (v3.26.0)
     cfg.lang komt uit request.locale (snippet). Onbekende taal = Nederlands.
     De teksten uit de thema-instellingen (welkom, knoppen…) kiest de snippet al per taal.
     -------------------------------------------------------------------- */
  var I18N = {
    nl: {
      askName: 'Vraag het {n}', chatWith: 'Chat met {n}', reset: 'Nieuw gesprek', closeChat: 'Chat sluiten', close: 'Sluiten',
      msgTo: 'Je bericht aan {n}', placeholder: 'Stel je vraag…', send: 'Versturen',
      aiNote: '{n} is een AI-assistent en kan zich vergissen.', privacy: 'Privacy', hide: 'Verbergen',
      hello: 'Hoi, ik ben {n}!', recommended: 'Aanbevolen producten', from: 'vanaf ',
      inStock: 'Op voorraad', soldOut: 'Tijdelijk uitverkocht', add: 'Toevoegen', adding: 'Toevoegen…', added: 'Toegevoegd',
      chooseVariant: 'Kies je variant', viewProduct: 'Bekijk product',
      addFailed: 'Ik kon {t} niet toevoegen. Probeer het op de productpagina.', thisProduct: 'dit product',
      hoTitle: 'Vraag doorsturen', hoLead: 'Ons team bekijkt je vraag en mailt je terug', hoMail: 'Mail je vraag naar',
      hoQuestion: 'Je vraag', hoEmail: 'E-mailadres', hoEmailPh: 'naam@voorbeeld.be', hoName: 'Naam', hoOptional: '(optioneel)',
      hoConsent: 'LUNÉA mag me over deze vraag mailen. Zie ons', hoPolicy: 'privacybeleid', hoSubmit: 'Verstuur naar ons team',
      hoSending: 'Versturen…', hoDone: 'Doorgestuurd', hoDoneLead: 'We mailen je terug op', hoThanks: 'Bedankt! We mailen je terug op',
      hoFailed: 'Versturen lukte niet. Mail je vraag naar',
      pEmail: 'een geldig e-mailadres', pQuestion: 'je vraag', pConsent: 'je toestemming', pFill: 'Vul nog {x} in.', pAnd: ' en ',
      typing: '{n} typt', connError: 'Er ging iets mis met de verbinding. Probeer het zo opnieuw, of mail ons op'
    },
    fr: {
      askName: 'Demandez à {n}', chatWith: 'Discuter avec {n}', reset: 'Nouvelle conversation', closeChat: 'Fermer le chat', close: 'Fermer',
      msgTo: 'Votre message à {n}', placeholder: 'Posez votre question…', send: 'Envoyer',
      aiNote: '{n} est une assistante IA et peut se tromper.', privacy: 'Confidentialité', hide: 'Masquer',
      hello: 'Bonjour, je suis {n} !', recommended: 'Produits recommandés', from: 'à partir de ',
      inStock: 'En stock', soldOut: 'Temporairement épuisé', add: 'Ajouter', adding: 'Ajout…', added: 'Ajouté',
      chooseVariant: 'Choisir une variante', viewProduct: 'Voir le produit',
      addFailed: "Je n'ai pas pu ajouter {t}. Veuillez réessayer depuis la page du produit.", thisProduct: 'ce produit',
      hoTitle: 'Transmettre votre question', hoLead: 'Notre équipe examine votre question et vous répond par e-mail', hoMail: 'Envoyez votre question à',
      hoQuestion: 'Votre question', hoEmail: 'Adresse e-mail', hoEmailPh: 'nom@exemple.fr', hoName: 'Nom', hoOptional: '(facultatif)',
      hoConsent: 'LUNÉA peut me contacter par e-mail au sujet de cette question. Consultez notre', hoPolicy: 'politique de confidentialité', hoSubmit: 'Envoyer à notre équipe',
      hoSending: 'Envoi…', hoDone: 'Transmis', hoDoneLead: 'Nous vous répondrons à', hoThanks: 'Merci ! Nous vous répondrons à',
      hoFailed: "L'envoi a échoué. Envoyez votre question à",
      pEmail: 'une adresse e-mail valide', pQuestion: 'votre question', pConsent: 'votre consentement', pFill: 'Veuillez encore indiquer {x}.', pAnd: ' et ',
      typing: '{n} écrit', connError: 'Un problème de connexion est survenu. Veuillez réessayer dans un instant ou nous écrire à'
    },
    de: {
      askName: 'Fragen Sie {n}', chatWith: 'Chat mit {n}', reset: 'Neues Gespräch', closeChat: 'Chat schließen', close: 'Schließen',
      msgTo: 'Ihre Nachricht an {n}', placeholder: 'Stellen Sie Ihre Frage…', send: 'Senden',
      aiNote: '{n} ist eine KI-Assistentin und kann sich irren.', privacy: 'Datenschutz', hide: 'Ausblenden',
      hello: 'Hallo, ich bin {n}!', recommended: 'Empfohlene Produkte', from: 'ab ',
      inStock: 'Auf Lager', soldOut: 'Vorübergehend ausverkauft', add: 'Hinzufügen', adding: 'Wird hinzugefügt…', added: 'Hinzugefügt',
      chooseVariant: 'Variante wählen', viewProduct: 'Produkt ansehen',
      addFailed: '{t} konnte nicht hinzugefügt werden. Bitte versuchen Sie es auf der Produktseite.', thisProduct: 'Dieses Produkt',
      hoTitle: 'Frage weiterleiten', hoLead: 'Unser Team prüft Ihre Frage und antwortet Ihnen per E-Mail', hoMail: 'Senden Sie Ihre Frage an',
      hoQuestion: 'Ihre Frage', hoEmail: 'E-Mail-Adresse', hoEmailPh: 'name@beispiel.de', hoName: 'Name', hoOptional: '(optional)',
      hoConsent: 'LUNÉA darf mir zu dieser Frage eine E-Mail senden. Siehe unsere', hoPolicy: 'Datenschutzerklärung', hoSubmit: 'An unser Team senden',
      hoSending: 'Wird gesendet…', hoDone: 'Weitergeleitet', hoDoneLead: 'Wir antworten Ihnen an', hoThanks: 'Vielen Dank! Wir antworten Ihnen an',
      hoFailed: 'Senden fehlgeschlagen. Senden Sie Ihre Frage an',
      pEmail: 'eine gültige E-Mail-Adresse', pQuestion: 'Ihre Frage', pConsent: 'Ihre Einwilligung', pFill: 'Bitte ergänzen Sie noch {x}.', pAnd: ' und ',
      typing: '{n} schreibt', connError: 'Es gab ein Verbindungsproblem. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie uns an'
    }
  };
  var LANG = String(cfg.lang || document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  if (!I18N[LANG]) LANG = 'nl';
  function t(key, vars) {
    var str = I18N[LANG][key];
    if (str == null) str = I18N.nl[key] || '';
    if (vars) Object.keys(vars).forEach(function (k) { str = str.split('{' + k + '}').join(vars[k]); });
    return str;
  }
  var KEY_SID = 'lunea:evelyne:sid';
  var KEY_LOG = 'lunea:evelyne:log';
  var KEY_OPEN = 'lunea:evelyne:open';
  var KEY_TEASE = 'lunea:evelyne:teased';
  var MAX_LOG = 60;
  var TIMEOUT = 45000;

  /* ----------------------------------------------------------------------
     Opslag — altijd in try/catch (privémodus, geblokkeerde cookies)
     -------------------------------------------------------------------- */
  function store(type) {
    try { var s = window[type]; var k = '__lue'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) { /* vol of geblokkeerd */ } }
  function del(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }

  function newId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'lue-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  var sessionId = get(LS, KEY_SID);
  if (!sessionId) { sessionId = newId(); set(LS, KEY_SID, sessionId); }

  var log = [];
  try { log = JSON.parse(get(SS, KEY_LOG) || '[]') || []; } catch (e) { log = []; }
  function saveLog() { set(SS, KEY_LOG, JSON.stringify(log.slice(-MAX_LOG))); }

  /* ----------------------------------------------------------------------
     Hulpjes
     -------------------------------------------------------------------- */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var ICON = {
    close: '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    reset: '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    send: '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    bag: '<svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8zM9 8a3 3 0 0 1 6 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    check: '<svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function avatarHtml() {
    if (cfg.avatar) return '<span class="lue-avatar"><img src="' + esc(cfg.avatar) + '" alt="" width="88" height="88" loading="lazy"></span>';
    return '<span class="lue-avatar" aria-hidden="true">' + esc((cfg.name || 'E').charAt(0)) + '</span>';
  }

  /* Veilige links: alleen relatief, mailto of eigen domein */
  function safeUrl(u) {
    u = String(u || '').trim();
    if (/^\/(?!\/)/.test(u)) return u;
    if (/^mailto:[^\s"'<>]+$/i.test(u)) return u;
    var m = u.match(/^https?:\/\/([^/?#]+)/i);
    if (m) {
      var host = m[1].toLowerCase();
      if (host === location.host.toLowerCase() || (cfg.domains || []).indexOf(host) !== -1) return u;
    }
    return null;
  }

  /* Mini-markdown: vet, links, lijstjes, alinea's. Eerst escapen, dan opmaken. */
  function md(text) {
    var lines = esc(text).replace(/\r/g, '').split('\n');
    var out = [], para = [], list = [];
    function inline(s) {
      return s
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (all, label, url) {
          var u = safeUrl(url.replace(/&amp;/g, '&'));
          if (!u) return label;
          var ext = /^https?:/i.test(u) && u.indexOf(location.host) === -1;
          return '<a href="' + esc(u) + '"' + (ext ? ' target="_blank" rel="noopener"' : '') + '>' + label + '</a>';
        });
    }
    function flushP() { if (para.length) { out.push('<p>' + inline(para.join('<br>')) + '</p>'); para = []; } }
    function flushL() { if (list.length) { out.push('<ul>' + list.map(function (li) { return '<li>' + inline(li) + '</li>'; }).join('') + '</ul>'); list = []; } }
    lines.forEach(function (ln) {
      var t = ln.trim();
      var m = t.match(/^[-*•]\s+(.*)$/);
      if (m) { flushP(); list.push(m[1]); }
      else if (!t) { flushP(); flushL(); }
      else { flushL(); para.push(t.replace(/^#+\s*/, '')); }
    });
    flushP(); flushL();
    return out.join('');
  }

  /* Antwoord splitsen in tekst + blokken */
  function parseReply(raw) {
    var res = { text: '', producten: [], keuzes: [], doorsturen: null };
    var text = String(raw || '');
    text = text.replace(/```\s*(producten|products|keuzes|doorsturen)\s*\n?([\s\S]*?)```/gi, function (all, kind, body) {
      kind = kind.toLowerCase();
      var data = null;
      try { data = JSON.parse(body.trim()); } catch (e) { data = null; }
      if (kind === 'producten' || kind === 'products') {
        if (Array.isArray(data)) {
          res.producten = data.map(function (x) { return typeof x === 'string' ? x : (x && x.handle); })
            .filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(h); })
            .slice(0, 4);
        }
      } else if (kind === 'keuzes') {
        if (Array.isArray(data)) res.keuzes = data.filter(function (x) { return typeof x === 'string' && x.trim(); }).slice(0, 5);
      } else if (kind === 'doorsturen') {
        res.doorsturen = { vraag: (data && typeof data.vraag === 'string') ? data.vraag : '' };
      }
      return '';
    });
    res.text = text.replace(/\n{3,}/g, '\n\n').trim();
    return res;
  }

  /* ----------------------------------------------------------------------
     Opbouw
     -------------------------------------------------------------------- */
  root.className = 'lue' + (cfg.position === 'left' ? ' lue--left' : '') + (cfg.mobile === false ? ' lue--nomobile' : '');
  document.body.classList.add('lue-active');
  if (cfg.position === 'left') document.body.classList.add('lue-left');

  var name = cfg.name || 'Evelyne';
  var panelId = 'lue-panel';

  root.innerHTML =
    '<button type="button" class="lue-launcher" aria-expanded="false" aria-controls="' + panelId + '">' +
      avatarHtml() + '<span class="lue-launcher__dot" aria-hidden="true"></span>' +
      '<span class="lue-launcher__label">' + esc(cfg.launcherLabel || t('askName', { n: name })) + '</span>' +
    '</button>' +
    '<section class="lue-panel" id="' + panelId + '" role="dialog" aria-modal="false" tabindex="-1" aria-label="' + esc(t('chatWith', { n: name })) + '">' +
      '<div class="lue-head">' + avatarHtml() +
        '<div class="lue-head__text"><p class="lue-head__name">' + esc(name) + '</p><p class="lue-head__role">' + esc(cfg.role || '') + '</p></div>' +
        '<button type="button" class="lue-iconbtn" data-lue-reset aria-label="' + esc(t('reset')) + '" title="' + esc(t('reset')) + '">' + ICON.reset + '</button>' +
        '<button type="button" class="lue-iconbtn" data-lue-close aria-label="' + esc(t('closeChat')) + '" title="' + esc(t('close')) + '">' + ICON.close + '</button>' +
      '</div>' +
      '<div class="lue-log" role="log" aria-live="polite" aria-relevant="additions"></div>' +
      '<div class="lue-foot">' +
        '<div class="lue-chips lue-chips--start" data-lue-start></div>' +
        '<form class="lue-form" novalidate>' +
          '<label class="lue-sr" for="lue-text">' + esc(t('msgTo', { n: name })) + '</label>' +
          '<textarea id="lue-text" class="lue-text" rows="1" maxlength="1000" placeholder="' + esc(cfg.placeholder || t('placeholder')) + '" autocomplete="off"></textarea>' +
          '<button type="submit" class="lue-send" aria-label="' + esc(t('send')) + '" disabled>' + ICON.send + '</button>' +
        '</form>' +
        '<p class="lue-note">' + esc(t('aiNote', { n: name })) + ' <a href="' + esc(cfg.privacyUrl || '/policies/privacy-policy') + '">' + esc(t('privacy')) + '</a></p>' +
      '</div>' +
    '</section>';

  var launcher = root.querySelector('.lue-launcher');
  var panel = root.querySelector('.lue-panel');
  var logEl = root.querySelector('.lue-log');
  var form = root.querySelector('.lue-form');
  var input = root.querySelector('.lue-text');
  var sendBtn = root.querySelector('.lue-send');
  var startChips = root.querySelector('[data-lue-start]');
  var busy = false;
  var teaser = null;

  /* ----------------------------------------------------------------------
     Openen / sluiten
     -------------------------------------------------------------------- */
  function isOpen() { return root.classList.contains('is-open'); }

  /* Mobiel = smal scherm of liggende telefoon. Zelfde voorwaarde als de media query in lunea-evelyne.css. */
  var MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 600px), (max-height: 500px)') : null;
  function isMobile() { return !!(MOBILE_MQ && MOBILE_MQ.matches); }

  /* Op mobiel vult het paneel het zichtbare deel van het scherm. De visualViewport krimpt als het
     toetsenbord opent (iOS en Android verkleinen de pagina zelf niet); met die maten blijven de kop
     en het invoerveld allebei in beeld en springt er niets. */
  function syncViewport() {
    if (!isOpen() || !isMobile()) {
      root.style.removeProperty('--lue-vh');
      root.style.removeProperty('--lue-vt');
      return;
    }
    var vv = window.visualViewport;
    var h = vv ? vv.height : window.innerHeight;
    var t = vv ? Math.max(0, vv.offsetTop) : 0;
    var atBottom = logEl.scrollHeight - logEl.scrollTop - logEl.clientHeight < 48;
    root.style.setProperty('--lue-vh', Math.round(h) + 'px');
    root.style.setProperty('--lue-vt', Math.round(t) + 'px');
    if (atBottom) scrollDown(true);
  }
  var vvQueued = false;
  function queueSync() {
    if (vvQueued) return;
    vvQueued = true;
    requestAnimationFrame(function () { vvQueued = false; syncViewport(); });
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueSync);
    window.visualViewport.addEventListener('scroll', queueSync);
  }
  window.addEventListener('resize', queueSync);
  window.addEventListener('orientationchange', function () { setTimeout(syncViewport, 250); });

  /* Pagina erachter vastzetten zolang de chat op mobiel het hele scherm vult */
  function lockPage(on) {
    document.documentElement.classList.toggle('lue-lock', on);
    document.body.classList.toggle('lue-lock', on);
  }
  /* Draaien of venster verkleinen terwijl de chat open is: slot en maten meteen bijwerken */
  function onModeChange() {
    if (!isOpen()) return;
    lockPage(isMobile());
    syncViewport();
  }
  if (MOBILE_MQ) {
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', onModeChange);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(onModeChange);
  }

  function open(focus) {
    if (isOpen()) return;
    hideTeaser(true);
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    set(SS, KEY_OPEN, '1');
    if (isMobile()) { lockPage(true); syncViewport(); }
    if (!logEl.childNodes.length) renderAll();
    scrollDown(true);
    // Op mobiel niet meteen het toetsenbord openen (dat schuift over het gesprek):
    // de focus gaat naar het paneel, typen begint pas als de klant in het veld tikt.
    if (focus !== false) setTimeout(function () {
      if (isMobile()) panel.focus({ preventScroll: true });
      else input.focus({ preventScroll: true });
    }, 80);
  }
  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    del(SS, KEY_OPEN);
    lockPage(false);
    syncViewport();
    launcher.focus({ preventScroll: true });
  }

  launcher.addEventListener('click', function () { open(); });
  root.querySelector('[data-lue-close]').addEventListener('click', close);
  root.querySelector('[data-lue-reset]').addEventListener('click', function () {
    if (busy) return;
    log = []; saveLog();
    sessionId = newId(); set(LS, KEY_SID, sessionId);
    logEl.innerHTML = '';
    renderAll();
    input.focus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen() && !document.body.classList.contains('lu-cart-open')) close();
  });

  /* Andere scripts kunnen de chat openen: window.LuneaEvelyne.open('vraag') */
  window.LuneaEvelyne = {
    open: function (question) { open(); if (question) send(String(question)); },
    close: close
  };
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lunea-evelyne-open]');
    if (!t) return;
    e.preventDefault();
    window.LuneaEvelyne.open(t.getAttribute('data-lunea-evelyne-open'));
  });

  /* ----------------------------------------------------------------------
     Teaser-ballon
     -------------------------------------------------------------------- */
  function showTeaser() {
    if (!cfg.teaser || isOpen() || get(SS, KEY_TEASE) || log.length) return;
    teaser = el('div', 'lue-teaser');
    teaser.setAttribute('role', 'status');
    teaser.innerHTML = '<strong>' + esc(name) + '</strong>' + esc(cfg.teaser) +
      '<button type="button" class="lue-teaser__close" aria-label="' + esc(t('hide')) + '">' + ICON.close + '</button>';
    teaser.addEventListener('click', function (e) {
      if (e.target.closest('.lue-teaser__close')) { hideTeaser(true); return; }
      open();
    });
    root.appendChild(teaser);
  }
  function hideTeaser(remember) {
    if (remember) set(SS, KEY_TEASE, '1');
    if (teaser) { teaser.remove(); teaser = null; }
  }
  if (cfg.teaserDelay > 0) setTimeout(showTeaser, cfg.teaserDelay * 1000);

  /* ----------------------------------------------------------------------
     Weergave
     -------------------------------------------------------------------- */
  function scrollDown(instant) {
    requestAnimationFrame(function () {
      if (instant) { logEl.style.scrollBehavior = 'auto'; }
      logEl.scrollTop = logEl.scrollHeight;
      if (instant) { logEl.style.scrollBehavior = ''; }
    });
  }

  function renderStartChips() {
    startChips.innerHTML = '';
    var hasUser = log.some(function (m) { return m.rol === 'klant'; });
    if (hasUser || !(cfg.quick || []).length) { startChips.hidden = true; return; }
    startChips.hidden = false;
    cfg.quick.forEach(function (q) {
      var b = el('button', 'lue-chip');
      b.type = 'button'; b.textContent = q;
      b.addEventListener('click', function () { send(q); });
      startChips.appendChild(b);
    });
  }

  function renderAll() {
    logEl.innerHTML = '';
    addBubble('bot', md(cfg.welcome || t('hello', { n: name })), true);
    log.forEach(function (m, i) { renderEntry(m, i === log.length - 1); });
    renderStartChips();
    scrollDown(true);
  }

  function addBubble(who, html, isHtml) {
    var row = el('div', 'lue-msg lue-msg--' + who);
    if (who === 'bot' || who === 'error') row.innerHTML = avatarHtml();
    var b = el('div', 'lue-bubble');
    if (isHtml) b.innerHTML = html; else b.textContent = html;
    row.appendChild(b);
    logEl.appendChild(row);
    return row;
  }

  function renderEntry(m, isLast) {
    if (m.rol === 'klant') { addBubble('user', m.tekst); return; }
    if (m.rol === 'fout') { addBubble('error', md(m.tekst), true); return; }
    if (m.rol === 'systeem') { addBubble('bot', md(m.tekst), true); return; }
    if (m.tekst) addBubble('bot', md(m.tekst), true);
    if (m.producten && m.producten.length) renderProducts(m.producten);
    if (isLast && m.keuzes && m.keuzes.length) renderChoices(m.keuzes);
    if (m.doorsturen && !m.doorsturen.klaar) renderHandoff(m);
    if (m.doorsturen && m.doorsturen.klaar) renderHandoffDone(m.doorsturen.email);
  }

  function renderChoices(list) {
    var wrap = el('div', 'lue-chips');
    wrap.setAttribute('data-lue-choices', '');
    list.forEach(function (q) {
      var b = el('button', 'lue-chip');
      b.type = 'button'; b.textContent = q;
      b.addEventListener('click', function () { send(q); });
      wrap.appendChild(b);
    });
    logEl.appendChild(wrap);
  }
  function clearChoices() {
    Array.prototype.forEach.call(logEl.querySelectorAll('[data-lue-choices]'), function (n) { n.remove(); });
    startChips.hidden = true;
  }

  /* ---- Productkaarten: live gegevens uit de winkel, nooit uit het taalmodel ---- */
  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(SHOP_ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function img(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function renderProducts(handles) {
    var rail = el('div', 'lue-products');
    rail.setAttribute('aria-label', t('recommended'));
    handles.forEach(function () {
      var sk = el('div', 'lue-card lue-card--skeleton', '<span class="lue-card__media"></span><div class="lue-card__body"><span class="lue-card__vendor">&nbsp;</span><span class="lue-card__title">&nbsp;</span></div>');
      rail.appendChild(sk);
    });
    logEl.appendChild(rail);

    Promise.all(handles.map(fetchProduct)).then(function (list) {
      rail.innerHTML = '';
      list.forEach(function (p) { if (p && p.featured_image) rail.appendChild(card(p)); });
      if (!rail.children.length) rail.remove();
      scrollDown();
    });
  }

  function card(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var multi = (p.variants || []).length > 1;
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var url = p.url || (SHOP_ROOT + 'products/' + p.handle);
    var c = el('article', 'lue-card');
    c.innerHTML =
      '<a class="lue-card__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(p.featured_image, 320)) + '" alt="" loading="lazy" width="160" height="160"></a>' +
      '<div class="lue-card__body">' +
        '<span class="lue-card__vendor">' + esc(p.vendor || '') + '</span>' +
        '<a class="lue-card__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        '<span class="lue-card__price' + (sale ? ' lue-card__price--sale' : '') + '">' + (multi && p.price_varies ? t('from') : '') + money(p.price) +
          (sale ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
        '<span class="lue-card__stock' + (p.available ? '' : ' lue-card__stock--out') + '">' + (p.available ? t('inStock') : t('soldOut')) + '</span>' +
      '</div>';
    var body = c.querySelector('.lue-card__body');
    var btn;
    if (p.available && !multi) {
      btn = el('button', 'lue-card__btn', ICON.bag + '<span>' + esc(t('add')) + '</span>');
      btn.type = 'button';
      btn.addEventListener('click', function () { addToCart(v.id, btn, p.title); });
    } else {
      btn = el('a', 'lue-card__btn lue-card__btn--ghost', p.available ? t('chooseVariant') : t('viewProduct'));
      btn.href = url;
    }
    body.appendChild(btn);
    return c;
  }

  function addToCart(variantId, btn, title) {
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var label = btn.querySelector('span');
    label.textContent = t('adding');
    fetch(SHOP_ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.classList.add('is-done');
        btn.innerHTML = ICON.check + '<span>' + esc(t('added')) + '</span>';
        // Winkelwagenlade van het thema bijwerken en openen
        var atc = window.LuneaATC;
        if (atc && atc.refresh) {
          atc.refresh().then(function () {
            if (isMobile()) close();
            if (atc.open) atc.open();
          }).catch(function () {});
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
        setTimeout(function () {
          btn.disabled = false; btn.classList.remove('is-done');
          btn.innerHTML = ICON.bag + '<span>' + esc(t('add')) + '</span>';
        }, 2600);
      })
      .catch(function (err) {
        btn.disabled = false;
        label.textContent = t('add');
        addBubble('error', md((err && err.description) || t('addFailed', { t: title || t('thisProduct') })), true);
        scrollDown();
      });
  }

  /* ---- Doorstuurformulier ---- */
  var pendingHandoff = null;

  function renderHandoff(entry) {
    var box = el('form', 'lue-handoff');
    box.noValidate = true;
    var uid = 'lue-h-' + Math.random().toString(36).slice(2, 8);
    var vraag = (entry.doorsturen && entry.doorsturen.vraag) || lastUserText();
    var noUrl = !cfg.escalateUrl;
    box.innerHTML =
      '<p class="lue-handoff__title">' + esc(t('hoTitle')) + '</p>' +
      '<p class="lue-handoff__lead">' + esc(t('hoLead')) + (cfg.replyTime ? ', ' + esc(cfg.replyTime) : '') + '.</p>' +
      (noUrl
        ? '<p class="lue-handoff__lead">' + esc(t('hoMail')) + ' <a href="mailto:' + esc(cfg.email) + '">' + esc(cfg.email) + '</a>.</p>'
        : '<div><label for="' + uid + '-v">' + esc(t('hoQuestion')) + '</label><textarea id="' + uid + '-v" class="lue-input" name="vraag" rows="3" maxlength="2000" required>' + esc(vraag) + '</textarea></div>' +
          '<div><label for="' + uid + '-e">' + esc(t('hoEmail')) + '</label><input id="' + uid + '-e" class="lue-input" type="email" name="email" autocomplete="email" inputmode="email" required placeholder="' + esc(t('hoEmailPh')) + '" value="' + esc(entry.doorsturen.email || '') + '"></div>' +
          '<div><label for="' + uid + '-n">' + esc(t('hoName')) + ' <span style="font-weight:400;text-transform:none;letter-spacing:0">' + esc(t('hoOptional')) + '</span></label><input id="' + uid + '-n" class="lue-input" type="text" name="naam" autocomplete="name" maxlength="80"></div>' +
          '<input class="lue-hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<label class="lue-consent"><input type="checkbox" name="toestemming" required><span>' + esc(t('hoConsent')) + ' <a href="' + esc(cfg.privacyUrl || '/policies/privacy-policy') + '" target="_blank" rel="noopener">' + esc(t('hoPolicy')) + '</a>.</span></label>' +
          '<p class="lue-handoff__error" role="alert" hidden></p>' +
          '<button type="submit" class="lue-btn">' + esc(t('hoSubmit')) + '</button>');
    logEl.appendChild(box);
    if (noUrl) return;
    pendingHandoff = { box: box, entry: entry };

    box.addEventListener('submit', function (e) {
      e.preventDefault();
      submitHandoff(box, entry);
    });
  }

  function renderHandoffDone(email) {
    var box = el('div', 'lue-handoff lue-handoff--done');
    box.innerHTML = '<p class="lue-handoff__title">' + esc(t('hoDone')) + '</p><p class="lue-handoff__lead">' + esc(t('hoDoneLead')) + ' <strong>' + esc(email || '') + '</strong>.</p>';
    logEl.appendChild(box);
  }

  function lastUserText() {
    for (var i = log.length - 1; i >= 0; i--) if (log[i].rol === 'klant') return log[i].tekst;
    return '';
  }

  function submitHandoff(box, entry) {
    var f = box.elements;
    var err = box.querySelector('.lue-handoff__error');
    var btn = box.querySelector('.lue-btn');
    var email = f.email.value.trim();
    var vraag = f.vraag.value.trim();
    var problems = [];
    f.email.removeAttribute('aria-invalid'); f.vraag.removeAttribute('aria-invalid');
    if (!EMAIL_RE.test(email)) { problems.push(t('pEmail')); f.email.setAttribute('aria-invalid', 'true'); }
    if (vraag.length < 3) { problems.push(t('pQuestion')); f.vraag.setAttribute('aria-invalid', 'true'); }
    if (!f.toestemming.checked) problems.push(t('pConsent'));
    if (problems.length) {
      err.hidden = false;
      err.textContent = t('pFill', { x: problems.join(', ').replace(/, ([^,]*)$/, t('pAnd') + '$1') });
      return;
    }
    err.hidden = true;
    btn.disabled = true; btn.textContent = t('hoSending');

    var gesprek = log.filter(function (m) { return m.rol === 'klant' || m.rol === 'bot'; }).slice(-12)
      .map(function (m) { return { rol: m.rol, tekst: String(m.tekst || '').slice(0, 600) }; });

    fetchJson(cfg.escalateUrl, {
      email: email,
      naam: f.naam.value.trim(),
      vraag: vraag,
      toestemming: true,
      website: f.website.value,
      gesprek: gesprek,
      pagina: location.href,
      sessionId: sessionId
    }, 20000)
      .then(function (res) {
        if (!res || res.ok !== true) throw new Error('niet ok');
        entry.doorsturen.klaar = true;
        entry.doorsturen.email = email;
        pendingHandoff = null;
        var done = el('div', 'lue-handoff lue-handoff--done');
        done.innerHTML = '<p class="lue-handoff__title">' + esc(t('hoDone')) + '</p><p class="lue-handoff__lead">' + esc(t('hoThanks')) + ' <strong>' + esc(email) + '</strong>' + (cfg.replyTime ? ', ' + esc(cfg.replyTime) : '') + '.</p>';
        box.replaceWith(done);
        saveLog();
        scrollDown();
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = t('hoSubmit');
        err.hidden = false;
        err.innerHTML = esc(t('hoFailed')) + ' <a href="mailto:' + esc(cfg.email) + '">' + esc(cfg.email) + '</a>.';
      });
  }

  /* ----------------------------------------------------------------------
     Versturen
     -------------------------------------------------------------------- */
  function fetchJson(url, body, timeout) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, timeout || TIMEOUT) : null;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { j = { output: t }; }
        if (!r.ok) { var e = new Error('HTTP ' + r.status); e.data = j; throw e; }
        return j;
      });
    }, function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  function typing() {
    var row = el('div', 'lue-msg lue-msg--bot');
    row.innerHTML = avatarHtml() + '<div class="lue-bubble lue-typing" aria-label="' + esc(t('typing', { n: name })) + '"><span></span><span></span><span></span></div>';
    logEl.appendChild(row);
    scrollDown();
    return row;
  }

  function pageContext() {
    var og = document.querySelector('meta[property="og:title"]');
    var title = (og && og.content) || document.title || '';
    return (title + ' (' + location.pathname + ')').slice(0, 200);
  }

  function send(text) {
    text = String(text || '').trim();
    if (!text || busy) return;

    // Staat er een doorstuurformulier open en typt de klant een e-mailadres? Dan hoort dat in het formulier.
    if (pendingHandoff && EMAIL_RE.test(text) && document.body.contains(pendingHandoff.box)) {
      var f = pendingHandoff.box.elements;
      f.email.value = text;
      input.value = ''; autosize(); toggleSend();
      pendingHandoff.box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      (f.toestemming.checked ? pendingHandoff.box.querySelector('.lue-btn') : f.toestemming).focus();
      return;
    }

    clearChoices();
    var entry = { rol: 'klant', tekst: text.slice(0, 1000) };
    log.push(entry); saveLog();
    addBubble('user', entry.tekst);
    input.value = ''; autosize(); toggleSend();
    busy = true; sendBtn.disabled = true;
    var dots = typing();

    fetchJson(cfg.chatUrl, {
      action: 'sendMessage',
      sessionId: sessionId,
      chatInput: entry.tekst,
      metadata: { pagina: pageContext(), taal: LANG }
    })
      .then(function (res) {
        dots.remove();
        var raw = (res && (res.output || res.text || res.message)) || '';
        if (!raw) throw new Error('leeg antwoord');
        var p = parseReply(raw);
        var bot = { rol: 'bot', tekst: p.text, producten: p.producten, keuzes: p.keuzes };
        if (p.doorsturen) {
          var emailInText = (text.match(/[^\s@]+@[^\s@]+\.[^\s@]{2,}/) || [])[0];
          bot.doorsturen = { vraag: p.doorsturen.vraag || lastUserText(), email: emailInText || '' };
        }
        log.push(bot); saveLog();
        renderEntry(bot, true);
        scrollDown();
      })
      .catch(function () {
        dots.remove();
        var msg = { rol: 'fout', tekst: t('connError') + ' [' + cfg.email + '](mailto:' + cfg.email + ').' };
        log.push(msg); saveLog();
        renderEntry(msg, true);
        scrollDown();
      })
      .then(function () {
        busy = false; toggleSend();
        if (isOpen() && !isMobile()) input.focus({ preventScroll: true });
      });
  }

  function autosize() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight + 2, 120) + 'px';
  }
  function toggleSend() { sendBtn.disabled = busy || !input.value.trim(); }

  input.addEventListener('input', function () { autosize(); toggleSend(); });
  /* Toetsenbord opent: iOS meldt de nieuwe hoogte soms pas na de animatie */
  input.addEventListener('focus', function () {
    if (!isMobile()) return;
    setTimeout(syncViewport, 120);
    setTimeout(syncViewport, 420);
  });
  input.addEventListener('blur', function () {
    if (isMobile()) setTimeout(syncViewport, 250);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(input.value); }
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });

  /* Gesprek liep al op een vorige pagina en stond open → open laten */
  if (get(SS, KEY_OPEN) && !isMobile()) open(false);
})();
